// root data
import cookie from 'util/cookie.js'

export default {
    logedin: cookie.getCookie('account') ? true : false,
}